import Avatar from '../../lib/avatar';
import { SECTION_COLOR, casSmeny, formatCasListu, druhyUcastnik } from './komunikace';

/**
 * Třetí sloupec bez vybrané konverzace (`panelVzdy`) — „Dnes": co čeká
 * na přečtení a kdo je dnes v práci. Místo plochy „Vyberte konverzaci",
 * kterou norma zakazuje.
 */
export default function PrehledDnes({ konverzace, lide, user, onlineIds, isDark, cardStyle, onVyber, onKarta }) {
    const muted = isDark ? 'rgba(255,255,255,0.45)' : 'var(--text-muted)';
    const cara = isDark ? 'rgba(255,255,255,0.06)' : 'var(--border-subtle)';
    const nadpis = { fontSize: 10.5, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: muted, margin: '0 0 8px' };

    const neprectene = konverzace.filter(k => k.neprectenych > 0);
    const celkem = neprectene.reduce((s, k) => s + k.neprectenych, 0);
    const naSmene = (lide || []).filter(c => c.smena);
    const nazev = (k) => k.nazev || druhyUcastnik(k, user?.id)?.jmeno || 'Soukromý chat';

    return (
        <div className="rounded-xl" style={{ ...cardStyle, padding: 16 }}>
            <p style={nadpis}>Nepřečtené</p>
            <p className="tabular-nums" style={{ fontSize: 28, fontWeight: 800, color: 'var(--text-primary)', margin: '0 0 6px', lineHeight: 1.1 }}>{celkem}</p>
            {neprectene.length === 0 && <p className="text-xs" style={{ color: muted }}>Všechno přečtené.</p>}
            {neprectene.slice(0, 5).map(k => (
                <button key={k.id} type="button" onClick={() => onVyber(k.id)} className="flex items-center w-full text-left"
                    style={{ gap: 8, minHeight: 34, background: 'none', border: 'none', borderBottom: `1px solid ${cara}`, padding: 0, cursor: 'pointer' }}>
                    <span className="flex-1 min-w-0 truncate text-[13px]" style={{ color: 'var(--text-primary)' }}>{nazev(k)}</span>
                    <span className="text-[11px]" style={{ color: muted }}>{formatCasListu(k.posledni_zprava?.cas)}</span>
                    <span className="text-[11px] font-bold rounded-full tabular-nums" style={{ background: SECTION_COLOR, color: '#fff', padding: '0 6px', minWidth: 18, textAlign: 'center' }}>{k.neprectenych}</span>
                </button>
            ))}

            <p style={{ ...nadpis, marginTop: 20 }}>Dnes na směně · {lide === null ? '…' : naSmene.length}</p>
            {lide !== null && naSmene.length === 0 && <p className="text-xs" style={{ color: muted }}>Dnes nikdo z kolegů nemá směnu.</p>}
            {naSmene.map(c => (
                <button key={c.id} type="button" onClick={() => onKarta(c)} className="flex items-center w-full text-left"
                    style={{ gap: 8, minHeight: 36, background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                    <Avatar url={c.avatar_url} jmeno={c.jmeno} size={26} online={onlineIds.has(c.id)} isDark={isDark} />
                    <span className="flex-1 min-w-0 truncate text-[13px]" style={{ color: 'var(--text-primary)' }}>{c.jmeno}</span>
                    <span className="text-[11.5px] tabular-nums" style={{ color: muted }}>{casSmeny(c.smena.cas_od)}–{casSmeny(c.smena.cas_do)}</span>
                </button>
            ))}
        </div>
    );
}
